import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ClientMealsPlanDetails, type ClientNutrition } from "@fitness-app/data-models/entities/ClientNutrition";

import { type AsyncThunkCreator } from "../../../index";
import { MEALS_PLANS_REDUCER_NAME } from "../types";

type Payload = {
  id: string;
  refetch?: boolean;
  keepCurrent?: boolean;
};

export const fetchMealsPlanWithDetails = createAsyncThunk<
  { plan: ClientNutrition; details: ClientMealsPlanDetails[] },
  Payload,
  AsyncThunkCreator<string>
>(`${MEALS_PLANS_REDUCER_NAME}/fetchMealsPlanWithDetails`, async (payload, { rejectWithValue, extra: { db } }) => {
  const query = db
    .from("client_meals_plan")
    .select("*, added:addedBy(id, firstName, lastName), details:client_meals_plan_details (*)")
    .eq("id", payload.id);

  const { error, data } = await query.single<ClientNutrition & { details: ClientMealsPlanDetails[] }>();

  if (error) {
    return rejectWithValue(error.message);
  }
  const { details, ...rest } = data;

  return {
    plan: rest,
    details: details,
  };
});
